module.exports = __webpack_public_path__ + "img/showcase-cards-fr-ca.b77a7eee.jpg";